<script>
import {computed} from "vue";

export default {
  name: "CheckBox",
  props: {
    text: {
      type: String,
    },
    modelValue: {
      type: Boolean,
    },
    labelColor: {
      type: String,
      default: 'var(--cd-text)'
    },
    backgroundColor: {
      type: String,
      default: 'var(--cd-base-green)'
    },
    tickColor: {
      type: String,
      default: '#FFFFFF'
    }
  },
  emits: ['update:modelValue', 'input', 'change'],
  setup(props, { emit }) {
    const currentValue = computed({
      get() {
        return props.modelValue;
      },
      set(value) {
        emit("update:modelValue", value);
        emit("input", value);
        emit("change", value);
      },
    });
    return {currentValue}
  }
}
</script>

<template>
  <label class="checkbox-container">
    <input
        type="checkbox"
        class="checkbox-input"
        v-model="currentValue"
    />
    <span class="checkbox-custom"></span>
    {{text}}<slot name="default"></slot>
  </label>
</template>

<style scoped lang="scss">
.checkbox-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  line-height: 19px;
  color: v-bind(labelColor);
  margin: 10px 0;
}

.checkbox-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkbox-custom {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border: 1px solid var(--cd-text-minor);
  border-radius: 2px;
  flex-shrink: 0;
}

.checkbox-input:checked ~ .checkbox-custom {
  background-color: v-bind(backgroundColor);
  border-color: v-bind(backgroundColor);
}

.checkbox-custom:after {
  content: "";
  display: none;
  width: 5px;
  height: 10px;
  border: solid v-bind(tickColor);
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  margin-bottom: 2px;
}

.checkbox-input:checked ~ .checkbox-custom:after {
  display: block;
}

</style>
